import Icon from '@components/Icon';
import { useStationMode } from '@hooks/station';
import { ParallaxCarousel } from '@components/ParallaxCarousel';
import useFeaturedAlbums from '@hooks/useFeaturedAlbums';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCarouselData } from '../../hooks/apiHooks/carouselHooks';
import FeaturedItems from './components/FeaturedItems';
import HomeCompanions from './components/HomeCompanions';
import HomeIndianMusic from './components/HomeIndianMusic';
import HomeMusic from './components/HomeMusic';
import HomeSerenityWellness from './components/HomeSerenityWellness';
import HomeWisdom from './components/HomeWisdom';
import { Features } from "../../config.ts";

export const Home = memo(() => {
  const { t } = useTranslation();
  const isStationMode = useStationMode();
  // Fetch featured albums once at home page level
  const {
    music,
    serenity,
    books,
    //indianMusic,
    musicGenres,
    serenityGenres,
    booksGenres,
    //indianMusicGenres,
    loading,
    error,
    filterByGenre,
  } = useFeaturedAlbums();

  const {
    data: carouselResponse,
    isLoading: carouselLoading,
    isFetched: carouselFetched,
  } = useCarouselData();
  const carouselData = carouselResponse?.data?.items || [];

  return (
    <div
      className={`w-full h-full overflow-auto ${
        isStationMode ? 'pb-10' : 'pb-60'
      } pt-0 sm:pt-[20px] na-scroll-container`}>
      {/* Main Carousel */}
      {(!isStationMode) && Features.enableParallaxCarousel && (
        <div className="mt-12">
          <ParallaxCarousel
            carouselData={carouselData}
            isLoading={carouselLoading}
            isFetched={carouselFetched}
          />
        </div>
      )}

      {/* Featured Header */}
      <div className="flex items-center justify-between mb-4 font-[NapsterSans] px-4 sm:px-6">
        <div className="flex gap-[6px] sm:gap-[8px] items-center">
          <Icon name="star-active" size={24} color="#ffffff" />
          <div className="flex gap-[6px] sm:gap-[8px] items-center text-[15px] sm:text-[18px] text-white font-bold leading-[normal]">
            {t('home.featured')}
          </div>
        </div>
      </div>
      <FeaturedItems />
      <HomeIndianMusic />
      <HomeMusic
        albums={music}
        loading={loading}
        error={error}
        filterByGenre={filterByGenre}
        genres={musicGenres}
      />
      <HomeCompanions />

      <HomeSerenityWellness
        albums={serenity}
        loading={loading}
        error={error}
        filterByGenre={filterByGenre}
        genres={serenityGenres}
      />
      <HomeWisdom
        albums={books}
        loading={loading}
        error={error}
        filterByGenre={filterByGenre}
        genres={booksGenres}
      />
    </div>
  );
});

Home.displayName = 'Home';
